import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Vehicle} from "domain-models"
import {date, number, vehicleAttribute} from "filters"
import React from "react"
import Trans from '../../../../../components/Trans'

type VehicleDetailsProps = {
  vehicle: Vehicle
}

class VehicleDetails extends React.Component<VehicleDetailsProps> {
  render() {
    const vehicle = this.props.vehicle
    return (
      <div className="w-full flex flex-row flex-wrap mt-10 md:mt-0 text-gray-700">
        <span className='font-semibold text-lg text-gray-700 w-full'>
          <Icon icon={['fas', 'list']}/> <Trans>Details</Trans>
        </span>

        <div className='flex flex-row flex-wrap w-full'>
          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Baujahr</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.Year || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Modelljahr</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.ModelYear || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Qualitätslabel</Trans></span>
            <span className="font-semibold text-gray-800">{vehicleAttribute('Label', vehicle.Label)}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Vorbesitzer</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.NumOwners, 0) || '0'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Hauptuntersuchung</Trans></span>
            <span className="font-semibold text-gray-800">{date(vehicle.InspectionDate)}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Anhängelast</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.TowingCapacityBraked, 0) || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Anhängelast ungebremst</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.TowingCapacityUnbraked, 0) || '-'}</span>
          </span>
        </div>
      </div>
    )
  }
}

export default VehicleDetails
